import React from 'react';
import NewPasswordSuccess from '@/components/NewPasswordSuccess/NewPasswordSuccess';
import { getCMSHomepageGrid } from '@/api/cms';
import { getOrFetchHeaderData } from '@/utils/headerCalls';
import LoginLayout from '@/components/LoginLayout/LoginLayout';
import { getLayoutProps } from '@/utils/layout/layout';

export default function ResetPassword({ logo, loginLogo, successImage, loginConfig, loginImage, responsiveLogo }) {
  return (
    <>
      <LoginLayout type={loginConfig} image={loginImage} responsiveLogo={responsiveLogo}>
        <NewPasswordSuccess logo={loginLogo ? loginLogo : logo} successImage={successImage} type={loginConfig} />
      </LoginLayout>
    </>
  );
}

export async function getStaticProps(context) {
  const { responsiveLogo } = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, context.locale);
  const [{ data: logoData }, { data: loginLogoData }, { data: loginAllData }] = await Promise.all([
    getCMSHomepageGrid('header_logo', context.locale),
    getOrFetchHeaderData('login_logo', context.locale),
    getOrFetchHeaderData('login_page', context.locale),
  ]);
  const logo = logoData.data[0].content.logo.url;
  const loginLogo = loginLogoData.data[0].content.login_logo.url;
  const loginConfig = loginAllData.data[0].content.configuration;
  const loginImage = loginAllData.data[0].content.image?.url ? loginAllData.data[0].content.image?.url : '';
  const successImage = loginAllData.data[0].content.success_password_change_image.url;

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
  };

  return {
    props: {
      responsiveLogo,
      logo,
      loginLogo,
      loginConfig,
      loginImage,
      successImage,
      messages,
    },
  };
}
